import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {SubscriptionsFilter, SubscriptionsList} from '../models/subscription';
import {ArrayResponse} from '..';

export const subListActionTypes = {
  TOGGLE_SEARCH: type('[Sub List] Toggle Search Form'),
  QUICK_SEARCH: type('[Sub List] Quick Search'),
  SEARCH: type('[Sub List] Search'),
  CHANGE_PAGE_SIZE: type('[Sub List] Change Page Size'),
  PAGE_TO: type('[Sub List] Page To'),
  ORDER_BY: type('[Sub List] Order By'),
  LOAD: type('[Sub List] Load'),
  LOAD_ANOMALY: type('[Sub List] Anomaly Load'),
  LOAD_MULTI_SUBSCRIPTION_BY_SITE: type('[Sub List by site] Multi Load'),
  LOAD_SUBSCRIPTION_BY_CLIENT: type('[Sub List by client] Load'),
  LOAD_SUBSCRIPTION_BY_CLIENT_SIMPLE: type('[Sub List by client Simple] Load'),
  LOAD_SUBSCRIPTION_BY_CONTRACT: type('[Sub List by contract] Load'),
  LOAD_SUCCESS: type('[Sub List] Load Success'),
  LOAD_FAIL: type('[Sub List] Load Fail'),
  SELECT_PAGE: type('[Sub List] Select Page'),
  SELECT_PAGE_SITE_CONTEXT: type('[Sub List] Select Page Site Context'),
  UNSELECT_PAGE: type('[Sub List] Unselect Page'),
  TOGGLE_SELECTION: type('[Sub List] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[Sub List] Toggle Selection Tags'),
  CLEAR: type('[Sub List] Clear Data'),
  CLEAR_ALL: type('[Sub List] Clearn All Data'),
  SELECT_ONE_ITEM: type('[Sub List] Selected one item'),
  CLEAR_ONE_ITEM: type('[Sub List] Clear one item'),
  SEND_EMAIL_FINANCE: type('[Sub List] Send email finance'),
  SEND_EMAIL_FINANCE_SUCCESS: type('[Sub List] Send email finance success'),
  EXPORT_ALL_SUBS: type('[sites] Export All Sub'),
  EXPORT_ALL_SUBS_SUCCESS: type('[sites] Export All Sub Success'),
  EXPORT_ANOMALY_TASK: type('[sites] Export anomaly task'),
  EXPORT_ANOMALY_TASK_SUCCESS: type('[sites] Export anomaly task Success'),
  EXPORT_CLIENT_SITE_SUBSCRIPTION: type('[client sites] Export client site subscription '),
  EXPORT_CLIENT_SITE_SUBSCRIPTION_SUCCESS: type('[client sites] Export client site subscription Success'),
};


export class ToggleSearchSubListAction implements Action {
  readonly type = subListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchSubListAction implements Action {
  readonly type = subListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchSubListAction implements Action {
  readonly type = subListActionTypes.SEARCH;
  constructor(public payload?: SubscriptionsFilter) {}
}

export class ChangeSubListPageSizeAction implements Action {
  readonly type = subListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageSubListToAction implements Action {
  readonly type = subListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderSubListByAction implements Action {
  readonly type = subListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadSubListAction implements Action {
  readonly type = subListActionTypes.LOAD;
  constructor() {}
}
export class LoadSubAnomalyListAction implements Action {
  readonly type = subListActionTypes.LOAD_ANOMALY;
  constructor() {}
}
export class LoadSubMultiListAction implements Action {
  readonly type = subListActionTypes.LOAD_MULTI_SUBSCRIPTION_BY_SITE;
  constructor() {}
}

export class LoadSubByClientListAction implements Action {
  readonly type = subListActionTypes.LOAD_SUBSCRIPTION_BY_CLIENT;
  constructor() {}
}
export class LoadSubByClientListSimpleAction implements Action {
  readonly type = subListActionTypes.LOAD_SUBSCRIPTION_BY_CLIENT_SIMPLE;
  constructor() {}
}
export class LoadSubByContractListAction implements Action {
  readonly type = subListActionTypes.LOAD_SUBSCRIPTION_BY_CONTRACT;
  constructor() {}
}

export class LoadSubListSuccessAction implements Action {
  readonly type = subListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<SubscriptionsList>) {}
}

export class LoadSubListFailAction implements Action {
  readonly type = subListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectSubListPageAction implements Action {
  readonly type = subListActionTypes.SELECT_PAGE;
  constructor() {}
}
export class SelectSubListPageSiteContextAction implements Action {
  readonly type = subListActionTypes.SELECT_PAGE_SITE_CONTEXT;
  constructor() {}
}

export class UnselectSubListPageAction implements Action {
  readonly type = subListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ToggleSubListSelectionAction implements Action {
  readonly type = subListActionTypes.TOGGLE_SELECTION;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class ClearSubListAction implements Action {
  readonly type = subListActionTypes.CLEAR;
  constructor() {}
}
export class SendEmailFinanceAction implements Action {
  readonly type = subListActionTypes.SEND_EMAIL_FINANCE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class SendEmailFinanceSuccessAction implements Action {
  readonly type = subListActionTypes.SEND_EMAIL_FINANCE_SUCCESS;
  constructor() {}
}

export class ClearALLSubListAction implements Action {
  readonly type = subListActionTypes.CLEAR_ALL;
  constructor() {}
}
export class SelectOneItemSubListAction implements Action {
  readonly type = subListActionTypes.SELECT_ONE_ITEM;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class ClearOneItemSubListAction implements Action {
  readonly type = subListActionTypes.CLEAR_ONE_ITEM;
  constructor() {}
}
export class ExportExcelAllSubAction implements Action {
  readonly type = subListActionTypes.EXPORT_ALL_SUBS;
  constructor() {}
}
export class ExportExcelAllSubSuccessAction implements Action {
  readonly type = subListActionTypes.EXPORT_ALL_SUBS_SUCCESS;
  constructor() {}
}
export class ExportAnomalyTaskAction implements Action {
  readonly type = subListActionTypes.EXPORT_ANOMALY_TASK;
  constructor() {}
}
export class ExportAnomalyTaskSuccessAction implements Action {
  readonly type = subListActionTypes.EXPORT_ANOMALY_TASK_SUCCESS;
  constructor() {}
}
export class ExportClientSubscriptionAction implements Action {
  readonly type = subListActionTypes.EXPORT_CLIENT_SITE_SUBSCRIPTION;
  constructor() {}
}
export class ExportClientSubscriptionSuccessAction implements Action {
  readonly type = subListActionTypes.EXPORT_CLIENT_SITE_SUBSCRIPTION_SUCCESS;
  constructor() {}
}
